module.exports = __webpack_public_path__ + "img/wxyj.da3019e5.png";